<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="700" persistent>
        <v-card>
          <v-card-title class="text-h5 red darken-3 white--text">
            Confirmar el envio
          </v-card-title>
  
          <v-card-text>
            
            <!-- {{ envio }} -->
            
            <p class="text-center mt-4">
              ¿Estás seguro de que deseas enviar los datos del recibo a NetSuite?
            </p>
            <v-progress-linear v-if="loading" class="mt-2" indeterminate/>
            <p class="my-0 text-center red--text"> {{ msg }} </p>
            
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" :disabled="loading" outlined @click="enviar()"> Enviar </v-btn>
            <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import gql from 'graphql-tag';
  import xaxios from '@/xaxios';
import { get_factura_by_cufe } from '../views/upi/factura_ispi/facturafacil';
  export default {
      data() {
        return {
          loading: true,
          dialog: false,
          msg: '', 
          recibo: {},
          envio:{},
        };
      },
      methods: {
        async openmodal(recibo) {
          this.msg = '';
          this.envio = {};
          this.recibo = recibo;
          this.dialog = true;

          window.console.log( '>>>.',recibo,this.$store.state ); 
          this.envio.id = recibo.id; 
        
        const unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
        const sedeid = this.$store.state.CARGO.sede.id;
        window.console.log('unidaddddd', unidad_negocio);

        if( unidad_negocio==15 ){// para UPI se saca los datos del patner DGI
          const fact = await get_factura_by_cufe(recibo.cufe,unidad_negocio,sedeid)
          window.console.log('fact',fact);
          if(fact && !fact.xml_data){
            this.$root.$notify.show('No hay factura emitida', {color:'red',x: 'right',});
            this.dialog = false;
            return;
          }
          
          const parser = new DOMParser();
          const xmlString = fact.xml_data;
          const xmlDoc = parser.parseFromString(xmlString, "text/xml");
          const dNroDF = xmlDoc.getElementsByTagName("dNroDF")[0].textContent;
          const dFechaEm = xmlDoc.getElementsByTagName("dFechaEm")[0].textContent;
          const dQRCode = xmlDoc.getElementsByTagName("dQRCode")[0].textContent;
          
          this.envio.cuf = recibo.cufe;
          this.envio.factura_id = fact.id; // el id dgi no es numeral
          this.envio.url_siat = dQRCode;
          this.envio.nro_factura = parseInt(dNroDF);
          this.envio.fecha_emision = dFechaEm;

          this.envio.codigo_tipo_documento_sector = 5;
          this.envio.estado_factura = "VALIDADA";
          // this.envio.codigo_recepcion = fact.Venta.codigoRecepcion;

        }

        else if(recibo.factura_id){
            this.loading = true;
          const sql = gql`query{getInscripcion(id: ${recibo.inscripcion_id}) { id programa{id sucursal{id nit{id nro}}} ${''}}}`;
          let ins = await this.$apollo.query({ query: sql }).then(({data})=>data).catch(e=>e);
          let urlsuc = `${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${ins.getInscripcion.programa.sucursal.id}`
          let apikey = await xaxios.get(urlsuc).then(({ data }) => (data.apikey ? data.apikey : ''));

          let config = {
            method: 'get',
            url: `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/${recibo.factura_id}`,
            headers: { 'Content-Type': 'application/json',apikey: apikey },
          };

          let fact = await xaxios.request(config).then(({data})=>data).catch(e=>e);
          window.console.log(typeof(fact),fact);
          window.console.log('<><><><><><><>:::', fact);
          if(!fact.Venta) fact.Venta = fact.venta;  
          if( !fact.Venta ){
            // this.loading = false;
            this.msg = `No se pudo obtener datos de la factura ID[${recibo.factura_id}] `+fact;
            return;
          }

          this.envio.cuf = fact.Venta.cuf;
          this.envio.factura_id = ""+fact.Venta.id;
          this.envio.url_siat = fact.Venta.urlSiat;
          this.envio.nro_factura = parseInt(recibo.numero_factura);
          this.envio.fecha_emision = fact.Venta.fechaEmision;
          this.envio.codigo_tipo_documento_sector = fact.Venta.codigoDocumentoSector;
          this.envio.codigo_recepcion = fact.Venta.codigoRecepcion;
          this.envio.estado_factura = fact.Venta.estado;
        }
        this.loading = false; 
          
        },
        cerrar() { 
            this.dialog = false;
        },
        /* parsefecha(f){
          return f.split('T')[0]
        }, */
        async enviar(){
          this.msg = '';
          this.loading = true;
          let ur = `${process.env.VUE_APP_API_REST}/api/v1/esam/pagos_inscripcion_queue`;
          let res = await xaxios.post(ur,this.envio).then(d=>d).catch(e=>e);
          window.console.log('res',res);
          if(res && res.response){
            window.console.log('res',res.response.data.data);
            this.loading = false;
            this.msg = res.response.data.data;
          }else{
            this.dialog = false;
            this.$emit('enviado');
          }

        }
      },
    };
  </script>
  